export default __webpack_public_path__ + "static/media/en-1yearfree.04d4cca7.svg";